import React from 'react';
import { FadeIn } from './FadeIn';
export function ProblemSection() {
  return <section className="py-16 sm:py-24 px-4 bg-running-surface relative" data-id="element-138">
      <div className="max-w-3xl mx-auto" data-id="element-139">
        <FadeIn data-id="element-140">
          <div className="prose prose-invert prose-lg sm:prose-xl max-w-none" data-id="element-141">
            <p className="text-gray-300 leading-relaxed mb-6" data-id="element-142">
              Hay algo que ningún profe de running dice en voz alta pero que
              casi todos sienten.
            </p>
            <p className="text-gray-300 leading-relaxed mb-6" data-id="element-143">
              No es que no saben entrenar.
            </p>
            <p className="text-gray-300 leading-relaxed mb-6" data-id="element-144">
              No es que no les apasiona el running.
            </p>
            <p className="text-gray-300 leading-relaxed mb-8" data-id="element-145">
              Es algo más incómodo que eso.
            </p>

            <div className="bg-running-dark border-l-4 border-running-blue p-6 sm:p-8 rounded-r-xl mb-10 shadow-lg" data-id="element-146">
              <p className="text-white font-medium leading-relaxed mb-4" data-id="element-147">
                Es la sensación de que después de años dando clases, después de
                certificaciones, después de cientos de kilómetros recorridos
                junto a sus alumnos, todavía llegan al domingo con la misma
                pregunta:
              </p>
              <p className="text-2xl sm:text-3xl font-display font-bold text-running-blue mt-6" data-id="element-148">
                ¿Qué hago con mis grupos la semana que viene?
              </p>
            </div>

            <p className="text-gray-300 leading-relaxed mb-6" data-id="element-149">
              Y ahí empieza el ciclo. Abrís el celular. Buscás en Instagram.
              Revisás grupos de WhatsApp de profes. Copiás algo que viste en un
              video. Armás algo que "más o menos sirve". Y el domingo que era
              para descansar se convierte en otra jornada de trabajo no pago que
              nadie ve y que nadie valora.
            </p>

            <p className="text-gray-300 leading-relaxed font-bold mb-12" data-id="element-150">
              Incluyendo vos.
            </p>

            <div className="text-center mb-12" data-id="element-151">
              <h2 className="text-3xl sm:text-4xl font-display font-bold text-white mb-4" data-id="element-152">
                El problema no es tu nivel. <br className="hidden sm:block" data-id="element-153" />
                <span className="text-running-blue" data-id="element-154">
                  Es que nadie te dio el sistema completo.
                </span>
              </h2>
              <p className="text-gray-400" data-id="element-155">
                Te formaste para entrenar corredores. No para ser:
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mb-12" data-id="element-156">
              {['Fisiólogo del ejercicio', 'Planificador anual', 'Especialista en nutrición', 'Experto en recuperación', 'Preparador de fuerza', 'Gestor de negocio'].map((role, i) => <div key={i} className="bg-running-dark border border-running-muted p-4 rounded-lg text-center flex items-center justify-center" data-id="element-157">
                  <span className="font-medium text-gray-200" data-id="element-158">{role}</span>
                </div>)}
            </div>

            <p className="text-gray-300 leading-relaxed mb-6" data-id="element-159">
              Pero eso es exactamente lo que te pide la realidad de entrenar
              corredores hoy.
            </p>
            <p className="text-gray-300 leading-relaxed" data-id="element-160">
              Y sin un sistema que sostenga todo eso, el resultado es siempre el
              mismo:{' '}
              <strong className="text-white" data-id="element-161">
                improvisación crónica, alumnos que se estancan, lesiones que se
                repiten y la sensación de que podrías dar mucho más de lo que
                das.
              </strong>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}